import { Alert } from "@mui/material";
import type { FC } from "react";
import { useAssets } from "../../../../assets/hooks/use-assets";
import { ContentLibraryEmptyModal } from "./content-library/content-library-empty-modal";
import { ContentLibraryModal } from "./content-library/content-library-modal";

export const FromContentLibraryModal: FC<{
  open: boolean;
  onClose: () => void;
}> = ({ open, onClose }) => {
  const { data, error } = useAssets();

  if (error)
    return (
      <Alert severity="error">
        Sorry, there was a problem retrieving your content. Please try again later
      </Alert>
    );

  return data && data.length > 0 ? (
    <ContentLibraryModal open={open} onClose={onClose} assets={data} />
  ) : (
    <ContentLibraryEmptyModal open={open} onClose={onClose} />
  );
};
